export default "__VITE_ASSET__DsuRL5tA__"